module.exports = __webpack_public_path__ + "static/media/V2_23.91c43643.png";